import { FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { siteStats } from "@/mocks/site";

const quickTags = ["今日话题", "热帖推荐", "生活茶话会", "职场唠嗑", "美食瓜田"];

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/topics?q=${encodeURIComponent(value)}` : "/topics");
  };

  return (
    <section className="relative w-full">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20artistic%20illustration%20of%20a%20sunny%20green%20melon%20field%20with%20floating%20chat%20bubbles%20and%20warm%20golden%20light%2C%20soft%20painterly%20texture%2C%20lively%20friendly%20community%20mood%2C%20deep%20green%20and%20warm%20cream%20tones%2C%20cinematic%20wide%20composition&width=1800&height=1000&seq=gt-hero-main&orientation=landscape"
          alt="瓜田社区热闹的线上唠嗑现场插画"
          title="瓜田社区 - 今日话题与热帖推荐"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/60 to-foreground-950/80" />
      </div>

      <div className="relative mx-auto w-full max-w-[1240px] px-4 pb-14 pt-16 md:px-6 md:pb-20 md:pt-24">
        <div className="w-full max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-3 py-1.5 text-xs text-background-100 backdrop-blur">
            <span className="flex h-2 w-2">
              <span className="h-2 w-2 animate-ping rounded-full bg-accent-400" />
            </span>
            此刻有 23,508 位瓜友在线讨论
          </span>

          <h1 className="mt-6">
            <span className="block font-brand text-5xl leading-none text-background-50 md:text-7xl">
              瓜田社区
            </span>
            <span className="mt-4 block text-lg font-medium text-background-100 md:mt-5 md:text-2xl">
              有瓜一起吃，有话大家聊
            </span>
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200/90 md:text-base">
            看今日话题、翻热帖推荐，在讨论版发帖互动、回帖讨论。这里汇聚海量吃瓜群众，实时更新讨论版精华内容，无论你追热点还是聊日常，都能找到同好。
          </p>

          <form
            onSubmit={handleSearch}
            className="mt-7 flex w-full max-w-xl items-center gap-2 rounded-full border border-background-50/25 bg-background-50/95 p-1.5 backdrop-blur"
          >
            <span className="flex h-9 w-9 shrink-0 items-center justify-center text-lg text-foreground-500">
              <i className="ri-search-line" />
            </span>
            <input
              type="text"
              name="keyword"
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜话题、板块或关键词，比如“通勤”“养猫”"
              aria-label="搜索社区话题"
              className="min-w-0 flex-1 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
            <button
              type="submit"
              className="flex h-9 shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-search-2-line" />
              搜一搜
            </button>
          </form>

          <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-background-300">
            <span className="text-background-400">大家常搜：</span>
            {quickTags.map((tag) => (
              <Link
                key={tag}
                to={`/topics?q=${encodeURIComponent(tag)}`}
                className="whitespace-nowrap transition-colors hover:text-secondary-300"
              >
                {tag}
              </Link>
            ))}
          </div>

          <div className="mt-9 flex flex-wrap items-center gap-3">
            <Link
              to="/topics"
              className="flex h-11 items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
            >
              <i className="ri-quill-pen-line" />
              进入讨论版发帖
            </Link>
            <a
              href="#hot"
              className="flex h-11 items-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 px-5 text-sm text-background-100 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-fire-line" />
              看热帖推荐
            </a>
          </div>
        </div>

        <dl className="mt-12 grid grid-cols-2 gap-x-4 gap-y-6 border-t border-background-50/20 pt-8 md:mt-16 md:grid-cols-4">
          {siteStats.map((stat) => (
            <div key={stat.label} className="flex items-center gap-3">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-background-50/12 text-xl text-secondary-300">
                <i className={stat.icon} />
              </span>
              <div>
                <dt className="text-xs text-background-300">{stat.label}</dt>
                <dd className="mt-0.5 text-xl font-semibold text-background-50 md:text-2xl">
                  {stat.value}
                </dd>
              </div>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}